import script from "./WordsetSelect.js?vue&type=script&lang=js&external"
export * from "./WordsetSelect.js?vue&type=script&lang=js&external"

import "./WordsetSelect.vue?vue&type=style&index=0&id=5de551ef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de551ef"]])

export default __exports__